import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ModulesApisService } from '../services/modules-apis.service';

@Component({
  selector: 'app-view-video-appt-waiting-room-pt',
  templateUrl: './view-video-appt-waiting-room-pt.page.html',
  styleUrls: ['./view-video-appt-waiting-room-pt.page.scss'],
})
export class ViewVideoApptWaitingRoomPtPage implements OnInit {

  @Input() public ptWaitingRoomList: any;
  
  constructor(private modalCtrl: ModalController,
    private moduleApi: ModulesApisService) { }

  ngOnInit() {
  }

  completeAppt(appt) {
    appt.apptStatus="completed"
    console.log("appt", appt);
    this.moduleApi
    .savePtVideoWaitingRoom(appt)
    .subscribe(data=>{
      console.log("data", data);
      if(data=="Success") {
        this.modalCtrl.dismiss();    
      }
    });
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

}
